import { Speaker as SpeakerModel } from '@goldcast/api/content';
import { LANDSCAPE_COMPILED_CONFIG, PORTRAIT_COMPILED_CONFIG, SQUARE_COMPILED_CONFIG } from '@goldcast/utils';
import { CSSProperties } from 'react';
import { SizeType } from './asset-types';

export type Speaker = Required<{
  [K in keyof SpeakerModel]: NonNullable<SpeakerModel[K]>;
}>;

export interface SpeakerWithDetails extends Omit<Speaker, 'face_ids'> {
  id: string;
  key: string;
  color: string;
  bgColor: string;
  lightBgColor: string;
  hoverBgColor: string;
  speakingSlots: Record<string, number>;
  parent_id: string | null;
  face_ids?: number[];
}
export enum Pronouns {
  SHE = 'she',
  HE = 'he',
  THEY = 'they'
}
export interface BaseConfig {
  style: { objectFit: string; width: string; height: string } | { display: CSSProperties['display'] };
  containerStyle:
    | {
        overflow: string;
        borderRadius?: string;
        position: string;
        top: string;
        left: string;
        width: string;
        height: string;
      }
    | { display: CSSProperties['display'] };
}
export interface CompiledConfig {
  [layoutType: string]: {
    [fitMode: string]: {
      [border: string]: {
        [totalParticipant: number]: BaseConfig[];
      };
    };
  };
}
export const layoutConfigMap: Record<SizeType, CompiledConfig> = {
  LANDSCAPE: LANDSCAPE_COMPILED_CONFIG,
  PORTRAIT: PORTRAIT_COMPILED_CONFIG,
  SQUARE: SQUARE_COMPILED_CONFIG
};
